import { render, staticRenderFns } from "./_RetailerReportIndex.vue?vue&type=template&id=c67c2ce6"
import script from "./_RetailerReportIndex.vue?vue&type=script&lang=js"
export * from "./_RetailerReportIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports